<template>
  <div class="content content--idea-form">
    <div class="bg-img">
      <img src="../../assets/images/hero-newidea.jpg">
    </div>

    <MyHeader :breadcrumbItems="[

        {
          name: 'Ideaboard',
          path: `/${$route.params.companySlug}/ideas`
        },
        {
          name: 'Add Idea',
          path: $route.path
        },
      ]"/>

    <header class="content-header">
      <h1>Add new idea</h1>
    </header>

    <div class="container main-content">
      <IdeaForm></IdeaForm>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/general/Header'
import IdeaForm from "@/components/ideas/IdeaForm";
export default {
  name: "IdeaFormPage",
  components: {MyHeader, IdeaForm},
  mounted() {
    window._paq.push(['setDocumentTitle', 'Add new idea']);
    window._paq.push(['trackPageView']);
  }
}
</script>

<style scoped>

</style>
